import type { Test, Manifests } from '../../common/api-client';
import React from 'react';
import type { manifestUtils } from '@deque/axe-devtools-issues-utils';
import { Panel } from '@deque/cauldron-react';
import TestOverview from './TestOverview';
import styles from './TestDetails.css';
import TestSummary from './TestSummary';
import IntelligentGuidedTests from './IntelligentGuidedTests';
import { type UpdateFilter } from '../../common/hooks/useIssuesFilter';
import type {
  UniversalIssueWithScreenshot,
  Filters
} from '@deque/axe-devtools-issues-utils';

interface TestDetailsProps {
  test: Test;
  issues: UniversalIssueWithScreenshot[];
  totalIssues: UniversalIssueWithScreenshot[];
  filters: Filters;
  updateFilter: UpdateFilter;
  narrow: boolean;
  manifests: Manifests;
  manifestRerunGroupsByType: manifestUtils.ManifestRerunGroupsByType;
}

const TestDetails: React.FC<TestDetailsProps> = ({
  test,
  issues,
  totalIssues,
  manifests,
  manifestRerunGroupsByType,
  filters,
  narrow,
  updateFilter
}) => {
  return (
    <Panel collapsed={narrow} className={styles.TestDetails}>
      <TestSummary test={test} filters={filters} updateFilter={updateFilter} />
      <TestOverview
        test={test}
        issues={issues}
        totalIssues={totalIssues}
        manifests={manifests}
        filters={filters}
      />
      <IntelligentGuidedTests
        issues={issues}
        manifestRerunGroupsByType={manifestRerunGroupsByType}
        filters={filters}
      />
    </Panel>
  );
};

export default TestDetails;
